export class Form {
    constructor(formNode, fields, states) {
        this.fields = fields;
        this.form = formNode;
        this.states = states;
    }

    sendRequest() {
        throw new Error('sendRequest request not implemented');
    }

    disable() {
        for (let key in this.fields) {
            this.fields[key].disable();
        }
    }

    initFields() {
        for (let key in this.fields) {
            if (typeof this.fields[key].init === 'function') {
                this.fields[key].init();
            }
        }
    }

    enable() {
        for (let key in this.fields) {
            this.fields[key].enable();
        }
    }

    init() {
        this.initFields();
        this.form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.onSubmit();
        });
    }

    formLoading() {
        this.resetServerError();
        this.form.classList.add(this.states.loading);
        this.disable();
    }

    responseSuccess() {
        this.form.classList.remove(this.states.loading);
        this.form.classList.add(this.states.success);
    }

    responseError() {
        this.resetFormStatuses();
        this.setServerError();
    }

    onSubmit() {
        this.formLoading();
        for (let key in this.fields) {
            if (this.fields[key].validate) {
                this.fields[key].validate();
                if (this.fields[key].invalid) {
                    this.enable();
                    return;
                }
            }
        }

        this.sendRequest();
    }

    setServerError() {
        this.form.classList.add(this.states.serverError);
    }

    resetServerError() {
        this.form.classList.remove(this.states.serverError);
    }

    resetFormStatuses() {
        this.form.classList.remove(this.states.loading);
        this.form.classList.remove(this.states.success);
        this.resetServerError();
        this.enable();
    }

    get value() {
        let valueObject = {};

        for (let objKey in this.fields) {
            valueObject[objKey] = this.fields[objKey].value;
        }

        return valueObject;
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/atoms/form/Form.js